module.exports = __webpack_public_path__ + "img/down-arrow.e527b38a.png";